module.exports = __webpack_public_path__ + "img/content-url.0617ba50.svg";